import Wrap from './styles';

export default (props) => {
  return (
    <Wrap>
      <p>
        Criamos essa área para que os usuários possam deixar sua opinião,
        sugestão, observação, etc.
      </p>
      <div className="dashed">
        Fale conosco atraves do email para{' '}
        <strong>novogeobahia@inema.ba.gov.br</strong>, ou caso seja usuário do
        Office365, clique aqui
      </div>
      <p>Equipe NOVO GEOBAHIA</p>
    </Wrap>
  );
};
